import React, { memo } from "react"
import { Tag } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JobListResponse } from "types/automation.types"
import { getStatusIcon, getStatusColor } from "utils/automationUtils"

interface CompletedJobItemProps {
  /** Job data to display */
  job: JobListResponse
}

/**
 * Component to display a completed job item in the list
 * Memoized to prevent unnecessary rerenders
 */
const CompletedJobItem: React.FC<CompletedJobItemProps> = memo(({ job }) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg mb-2 p-3 flex items-center gap-4">
      {/* Status Icon */}
      <div className="flex-shrink-0">
        <FontAwesomeIcon
          icon={getStatusIcon(job.status)}
          className="text-lg"
          style={{ color: getStatusColor(job.status) }}
        />
      </div>

      {/* Job Details */}
      <div className="flex-1 min-w-0">
        {/* Title */}
        <h4 className="font-medium text-gray-900 m-0 mb-1 truncate">
          {job.script}
        </h4>

        {/* Job Info */}
        <div className="text-sm text-gray-600 space-y-1">
          <div>Job ID: {job.job_id}</div>
          <div>User: {job.user_name}</div>
          <div>Unit: {job.unit_name}</div>
          {job.duration_seconds && <div>Duration: {job.duration_seconds}s</div>}
          {job.exit_code !== undefined && <div>Exit Code: {job.exit_code}</div>}
        </div>
      </div>

      {/* Status Tag */}
      <div className="flex-shrink-0">
        <Tag color={getStatusColor(job.status)}>{job.status}</Tag>
      </div>
    </div>
  )
})

CompletedJobItem.displayName = "CompletedJobItem"

export default CompletedJobItem
